<template lang="html">
  <div class="main">
    <div class="success" v-show="show">{{message.info1}}<a href="/app/login">{{message.login}}</a></div>
    <div class="fail" v-show="!show">{{message.info2}}<a href="/app/register">{{message.register}}</a>{{message.resetRegister}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        login: this.$lang.ui.form.login,
        register: this.$lang.ui.form.register,
        resetRegister: this.$lang.ui.form.resetRegister,
        info1: this.$lang.ui.notice.l104,
        info2: this.$lang.ui.notice.l105
      },
      show: true
    }
  },
  created () {
    this.$store.dispatch('activeApp', true)
    this.active()
  },
  methods: {
    active () {
      var token = this.getQuery('token')
      this.$http.post('/cydex/api/v1/register_activate', {
        'token': token
      })
        .then(response => {
          this.show = true
        })
        .catch(error => {
          if (error) {
            this.show = false
          }
        })
    },
    getQuery (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  margin-top: 120px;
  text-align: center;
  font-size: 18px;
}
a {
  color: #007bc5;
}
</style>
